import { FC, useState } from 'react';
import { SiPayModal } from 'utilities/components';
import { BsExclamationTriangle } from 'react-icons/bs';
import { Button } from '../button/button.index';

interface Props {
    variant: 'deposit' | 'withdrawal';
}

const CONTENT: Record<Props['variant'], string> = {
    deposit:
        'کاربران گرامی، به دلیل اختلال در زیر ساخت های بانکی خواهشمندیم از حساب های بانکی خود در بانک های ملی، صادرات و تجارت انتقال وجه ندهید. در غیر این صورت تراکنش شما تایید نخواهد شد.',
    withdrawal:
        'کاربران گرامی، به دلیل اختلال در زیر ساخت های بانکی خواهشمندیم برای برداشت وجه از حساب های بانکی خود در بانک های ملی، صادرات و تجارت استفاده نکنید. در غیر این صورت تراکنش شما تایید نخواهد شد.',
};

const BANK_TAGS = ['بانک ملی', 'بانک صادرات', 'بانک تجارت'];

export const BankDisruptionModal: FC<Props> = ({ variant }) => {
    const [isOpen, setIsOpen] = useState<boolean>(true);

    const handleClose = () => setIsOpen(false);

    return (
        <SiPayModal isOpen={isOpen} onClose={handleClose} maxWidth={440}>
            <div className="w-full flex flex-col items-center text-center">
                <div className="w-16 h-16 rounded-full bg-badge-warningBg flex items-center justify-center">
                    <BsExclamationTriangle size={28} className="text-warning-default" />
                </div>
                <span className="font-bold text-xl text-black-100 mt-5">اطلاعیه مهم</span>
                <p className="font-medium text-base text-black-100 leading-8 mt-4">{CONTENT[variant]}</p>
                <div className="flex flex-wrap items-center justify-center gap-3 mt-6">
                    {BANK_TAGS.map((tag) => (
                        <div
                            key={tag}
                            className="flex items-center gap-2 px-4 py-2 rounded-full bg-badge-warningBg text-warning-default text-sm font-medium"
                        >
                            <span className="w-1.5 h-1.5 rounded-full bg-warning-default" />
                            {tag}
                        </div>
                    ))}
                </div>
                <Button type="primary" className="w-full mt-8" onClick={handleClose}>
                    متوجه شدم
                </Button>
            </div>
        </SiPayModal>
    );
};
